import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=038da096&scoped=true&"
import script from "./InputSelect.vue?vue&type=script&lang=js&"
export * from "./InputSelect.vue?vue&type=script&lang=js&"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=038da096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038da096",
  null
  
)

export default component.exports